export const chartSmallConfig = {
  margin: { top: 0, right: 12, bottom: 25, left: 12 },
  enablePoints: false,
  colors: ["#14a077", "#496cdf", "#0DB6C9"],
  defs: [
    {
      colors: [
        // { color: '#14a077', offset: 0 },
        // { color: '#14a077', offset: 100, opacity: 0 }
      ],
      id: "gradient-green",
      // type: 'linearGradient'
    },
    {
      colors: [
        // { color: '#496cdf', offset: 0 },
        // { color: '#496cdf', offset: 100, opacity: 0 }
      ],
      id: "gradient-blue",
      // type: 'linearGradient'
    },
    {
      colors: [
        // { color: '#0DB6C9', offset: 0 },
        // { color: '#0DB6C9', offset: 100, opacity: 0 }
      ],
      id: "gradient-cyan",
      // type: 'linearGradient'
    },
  ],

  enableGridY: true,
  enableGridX: true,
  // enableArea: true,
  axisLeft: { legend: "count", legendOffset: -40 },
  // axisLeft: null,
  // axisBottom: null,

  enableLabel: true,
  theme: {
    labels: {
      text: {
        fontSize: 8,
      },
    },
  },
};
